import TableWithSorter from './TableWithSorter';
export default TableWithSorter;
